/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ t: NonNullable<unknown> }} External_Temperature_ValueInputs */



/**
* | output |
* | --- |
* | "Ext. temp.: {t}°C" |
*
* @param {External_Temperature_ValueInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const external_temperature_value = /** @type {((inputs: External_Temperature_ValueInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<External_Temperature_ValueInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Ext. temp.: ${i?.t}°C`)
	return /** @type {LocalizedString} */ (`T°ext : ${i?.t}°C`)
});